<div class="edit-job-container">
  <common-mojo-card>
    <div class="edit-job-card-content">
      <div class="edit-job-header">
        <div class="mat-headline-5">{{title$ | async}}</div>
        <button
          mat-flat-button
          class="md circle"
          [routerLink]="[routerLink$ | async]"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-divider></mat-divider>
      <mojo-jobs-form-page
        class="d-block mt-3"
        [job]="jobResponse"
        [editMode]="(fromCreateJob$ | async) === 'edit'"
        [isClonedJob]="isCurrentRouteClone() | async"
        (save)="finished=true"
      ></mojo-jobs-form-page>
    </div>
  </common-mojo-card>
</div>
